import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

// Pick a teammate to hand a batch of bids to.
export function ReassignDialog({ open, onOpenChange, count, onConfirm }) {
  const [users, setUsers] = useState([]);
  const [uid, setUid] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) { setUid(""); api.get("/users").then((r) => setUsers(r.data || [])).catch(() => {}); } }, [open]);
  const submit = async () => { if (!uid) return; setBusy(true); try { await onConfirm(uid); } finally { setBusy(false); } };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="reassign-dialog">
        <DialogHeader>
          <DialogTitle>Reassign {count} bid{count === 1 ? "" : "s"}</DialogTitle>
          <DialogDescription>Hand the selected {count === 1 ? "bid" : "bids"} to another teammate — they become the owner.</DialogDescription>
        </DialogHeader>
        <select className="border border-slate-200 rounded-md h-10 px-2 text-sm w-full focus:outline-none focus:border-[#003E87]"
          value={uid} onChange={(e) => setUid(e.target.value)} data-testid="reassign-select">
          <option value="">Choose a teammate…</option>
          {users.map((u) => <option key={u.user_id} value={u.user_id}>{(u.name || u.email)} · {u.role}</option>)}
        </select>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="reassign-cancel">Cancel</Button>
          <Button disabled={!uid || busy} onClick={submit} data-testid="reassign-confirm" className="bg-[#003E87] hover:bg-[#00305F] text-white">Reassign</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
